export const PUBLISH_EXAM_RESULT_APIS = {
  publish_results: "host/recorded/exams/report/publish",
};
